<template>
  <div>
    <div class="block">
      <div class="demonstration"
           data-test="date-picker--title">{{ title}}
      </div>
      <el-date-picker
        v-model="value1"
        type="date"
        size="large"
        placeholder="date de livraison souhaitée"
        :picker-options="pickerOptions"
        @change="emitDate()"
        data-test="date-picker--content">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
  import { basicUtils } from '../../utils/utils';

  export default {
    name: 'DatePicker',
    props: {
      title: String,
      supplier: String,
    },
    data() {
      return {
        value1: '',
        pickerOptions: {
          disabledDate(time) {
            const d = new Date();
            const timeToCompare = `${d.getHours()}.${d.getMinutes()}`;
            if (parseFloat(timeToCompare) > 11.30) {
              return time.getTime() < basicUtils.nextDay();
            }
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
      };
    },
    computed: {},
    methods: {
      emitDate() {
        this.$emit('emitDate', this.value1);
      },
    },
  };
</script>

<style lang="stylus">

</style>
